import React, { useState } from 'react';
import { fetchPractitionerByGsdlNo } from '../util/apiUtils';
import AlertMessage from '../AlertMessage';

/**
 * Displays a GSDLNO input and searches for practitioner details.
 *
 * @param props.onSubmit The function in which to pass the fetched practitioner object
 */
export default function AdminPractitionerSearch({ onSubmit }) {
	const [gsdlNo, setGsdlNo] = useState('');
	const [errorMessage, setErrorMessage] = useState(null);

	/**
	 * Fetches the practitioner details for the entered GSDLNO and passes the details to the onSubmit function.
	 */
	const handleSubmit = (evt) => {
		evt.preventDefault();
		setErrorMessage(null);
		if (!gsdlNo) {
			return;
		}

		if (onSubmit) {
			fetchPractitionerByGsdlNo(gsdlNo.toUpperCase())
				.then((json) => {
					if (json) {
						onSubmit(json);
					} else {
						setErrorMessage(`No details found for ${gsdlNo.toUpperCase()}.`);
					}
				})
				.catch((e) => {
					setErrorMessage(
						`An unexpected error occurred fetching practitioner details for ${gsdlNo.toUpperCase()}.`
					);
				});
		}
	};

	return (
		<form autoComplete="off" style={{ margin: '0px', display: 'inline-block' }} onSubmit={handleSubmit}>
			<div className="input-group" style={{ maxWidth: '180px' }}>
				<input
					type="text"
					className="form-control"
					maxLength="5"
					placeholder="GSDLNO"
					style={{ textTransform: 'uppercase' }}
					value={gsdlNo}
					onChange={(evt) => setGsdlNo(evt.target.value)}
				/>
				<span className="input-group-btn">
					<button
						className="btn btn-default"
						type="submit"
						style={{ minWidth: '0px', margin: '0px', padding: '9px 12px' }}
					>
						<i className="fa fa-w fa-search"></i>
					</button>
				</span>
			</div>
			{errorMessage && <AlertMessage type="danger">{errorMessage}</AlertMessage>}
		</form>
	);
}
